export default [{ id: 'users', labelStringId: 'users', path: '/users', icon: 'fa-thin fa-users' }];
